/* eslint-disable jsx-quotes */
import React from 'react';

import './styles.css';

export default class ItemOptionQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            option,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            showAllTextOption,
            handleShowAllTextOption,
            enableEditMode,
            editMode,
        } = this.props;
        return (
            <div className="container-option">
                <span className="header">
                    <span
                        className="description"
                        onClick={() => {
                            if (option.enabled && !editMode) {
                                handleSelectCorrectOptionQuestion(option.title);
                            }
                        }}
                    >
                        <span
                            className={
                                !option.correct
                                    ? 'indicate-correct'
                                    : 'indicate-correct highlight-correct'
                            }
                            onClick={() =>
                                handleSelectCorrectOptionQuestion(option.title)
                            }
                        >
                            {option.correct && (
                                <span className="checkmark"></span>
                            )}
                        </span>
                        <p>{option.title}</p>
                    </span>
                    <span className="line-actions">
                        {!editMode && (
                            <React.Fragment>
                                <button
                                    className="edit-question-btn"
                                    type="button"
                                    onClick={() => {
                                        if (enableEditMode) {
                                            enableEditMode({
                                                title: option.title,
                                                correct: option.correct,
                                            });
                                        }
                                    }}
                                >
                                    Editar
                                </button>
                                <button
                                    className={ option.correct ? 'disabled-button' : 'remove-button'}
                                    type="button"
                                    disabled={option.correct}
                                    onClick={() =>
                                        handleRemoveItemsOptionQuestion(
                                            option.title,
                                        )
                                    }
                                >
                                    Remover
                                </button>
                            </React.Fragment>
                        )}
                        <button
                            className="show-text-button"
                            type="button"
                            onClick={() =>
                                handleShowAllTextOption(showAllTextOption)
                            }
                        >
                            {showAllTextOption ? 'Ocultar' : 'Mostrar'}
                        </button>
                    </span>
                </span>
                {showAllTextOption && (
                    <span className="content-question">{option.title}</span>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/add-question/components/ItemOptionQuestion/ItemOptionQuestionPresentation.js